import React, { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import styles from "./navBarMenu.module.css";
import { useRef } from "react";
import { Dialog } from "primereact/dialog";
import logo from "../../../assets/img/LOGO-AULA-ABA-COLOR.png";
import { Sidebar } from "primereact/sidebar";
import { useDispatch, useSelector } from "react-redux";
import { SignIn } from "../../../store/auth-store/auth-actions";
import { userActions } from "../../../store/auth-store/auth-slice";
import { Password } from "primereact/password";
import { getTokenInfo } from "../../../utils/Guard";
import { Stepper } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";
import { ForgotPasswordAction } from "../../../store/auth-store/auth-actions";
import { useLocation } from "react-router-dom";
import DropdownMenu from "../../dropdownMenu/DropdownOptions.js";

const NavBarMenu = ({ img }) => {
  const dispatch = useDispatch();
  const userInfo = getTokenInfo();
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(false);

  const [visibleRight, setVisibleRight] = useState(false);

  const user = useSelector((state) => state.auth.auth);
  const notification = useSelector((state) => state.ui.notification);

  const stepperRef = useRef(null);
  const mobileMenu = [];

  const header = <img alt="Card" className={styles.logo} src={logo} />;

  useEffect(() => {
    if (window.innerWidth <= 1200 && !isMobile) {
      setIsMobile(true);
    }
  }, [isMobile]);

  useEffect(() => {
    if (
      notification !== null &&
      notification !== undefined &&
      notification.status === "success" &&
      user.loginVisible === true
    ) {
      dispatch(userActions.setLoginVisible(false));

      setTimeout(() => {
        window.location.href = "/";
      }, 1000);
    }
  });

  const onChangeHandler = (id, value) => {
    dispatch(userActions.modifyPropertyValue({ id, value }));
    if (value !== "") {
      dispatch(userActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(userActions.setFieldValid({ id, value: false }));
    }
  };

  useEffect(() => {
    if (
      userInfo !== undefined &&
      userInfo !== null &&
      userInfo.UserId !== null &&
      userInfo.UserId !== undefined &&
      userInfo.TemporalPassword == "True" &&
      window.location.pathname !== "/changepassword"
    ) {
      window.location.href = "/changepassword";
    }
  }, [userInfo]);

  useEffect(() => {
    if (
      userInfo !== undefined &&
      userInfo !== null &&
      userInfo.UserId !== null &&
      userInfo.UserId !== undefined &&
      userInfo.TemporalPassword == "False" &&
      window.location.pathname == "/changepassword"
    ) {
      window.location.href = "/";
    }
  }, [userInfo]);

  const onForgotPasswordHandler = () => {
    dispatch(userActions.setLoginVisible(true));
    dispatch(ForgotPasswordAction(user.email));
  };

  const logoutHandler = () => {
    localStorage.setItem("token", null);
    window.location.href = "/";
  };

  const onRegisterHandler = (event) => {
    dispatch(userActions.setLoginVisible(false));
    window.location.href = "/register";
  };
  const openForgotPasswordPage = (event) => {
    stepperRef.current.nextCallback();
  };
  const onSubmitHandler = async (event) => {
    dispatch(userActions.setLoginVisible(true));
    await dispatch(SignIn(user.email, user.password));

    if (user.loginVisible === false) {
      setVisibleRight(false);
    }
  };

  mobileMenu.push(
    {
      template: () => {
        return (
          <Button
            label="Capacitaciones"
            size="small"
            icon=""
            onClick={() => {
              window.location.href = "/courses/none";
            }}
            className={styles.dropdownMenu}
          />
        );
      },
    },
    {
      template: () => {
        return (
          <Button
            label="Microcredenciales"
            size="small"
            icon=""
            onClick={() => {
              window.location.href = "/async-courses/none";
            }}
            className={styles.dropdownMenu}
          />
        );
      },
    },
    {
      template: () => {
        return (
          <Button
            label="Bootcamps"
            size="small"
            icon=""
            onClick={() => {
              window.location.href = "/bootcamps";
            }}
            className={styles.dropdownMenu}
          />
        );
      },
    }
  );

  return (
    <>
      {location.pathname.includes("/forgotPassword") ? null : (
        <div className={styles.navBarMenuBar} id="hola">
          <img
            className={styles.navBarImage}
            alt="logo"
            src={img}
            onClick={() => {
              window.location.href = "/";
            }}
          />

          <div className={`flex `}>
            {/* <div className={styles.navBarSearch}>
          <div className={styles.searchItems}>
            <i className={`pi pi-search ${styles.searchIcon}`} />
            <InputText placeholder="Buscar..." className={styles.searchInput} />
          </div>
        </div> */}

            {!isMobile ? (
              <div className={`${styles.navBarMenuButtons}`}>
                <Button
                  className={`px-4 m-3 ${styles.navBarBootcampButton}`}
                  label="Bootcamps"
                  style={{ fontWeight: "100" }}
                  onClick={() => {
                    window.location.href = "/bootcamps";
                  }}
                />

                <Button
                  className={`${styles.navBarButton}`}
                  label="Capacitaciones"
                  style={{ fontWeight: "100" }}
                  onClick={() => {
                    window.location.href = "/courses/none";
                  }}
                />

                <Button
                  className={`${styles.navBarButton}`}
                  label="Microcredenciales"
                  style={{ fontWeight: "100" }}
                  onClick={() => {
                    window.location.href = "/async-courses/none";
                  }}
                />
              </div>
            ) : (
              <DropdownMenu
                icon={"pi pi-bars"}
                // title="Categorías"
                menu={mobileMenu}
                items={mobileMenu}
              />
            )}

            {userInfo !== null && userInfo !== undefined && userInfo !== "" ? (
              <Button
                className={`p-5 md:p-4 ml-3 ${styles.profileButton}`}
                icon="pi pi-user"
                rounded
                outlined
                severity="info"
                aria-label="User"
                onClick={() => setVisibleRight(true)}
              />
            ) : (
              <div
                onClick={() => {
                  dispatch(userActions.setLoginVisible(true));
                }}
                className={`${styles.loginButtonContainer}`}
              >
                <div className={`${styles.loginModalButton}`}>
                  Iniciar Sesión
                </div>
              </div>
            )}

            <Sidebar
              blockScroll
              visible={visibleRight}
              position="right"
              onHide={() => setVisibleRight(false)}
              className={styles.sideBar}
            >
              <div className={styles.sideBarProfileContainer}>
                <Button
                  className={styles.sideBarProfileIcon}
                  icon="pi pi-user"
                  rounded
                  outlined
                  severity="info"
                  aria-label="User"
                />
              </div>
              {userInfo !== null &&
              userInfo !== undefined &&
              userInfo !== "" ? (
                <h1 className={styles.sideBarName}>
                  {userInfo.Name + " " + userInfo.LastName}
                </h1>
              ) : null}
              <div className={styles.sideBarButtons}>
                <Button
                  className={styles.sideBarButton}
                  label="Mi perfil"
                  style={{ fontWeight: "100" }}
                  onClick={() => {
                    window.location.href = "/profile";
                  }}
                  icon="pi pi-user"
                />
                <Button
                  className={styles.sideBarButton}
                  label="Mis cursos"
                  style={{ fontWeight: "100" }}
                  onClick={() => {
                    window.location.href = "/mycourses";
                  }}
                  icon="pi pi-book"
                />
                <Button
                  className={styles.sideBarButton}
                  label="Ordenes y cotizaciones"
                  style={{ fontWeight: "100" }}
                  onClick={() => {
                    window.location.href = "/orders";
                  }}
                  icon="pi 
pi-receipt"
                />
                <Button
                  className={styles.sideBarLogoutButton}
                  label="Cerrar sesión"
                  onClick={() => {
                    logoutHandler();
                  }}
                  icon="pi pi-sign-out"
                />
              </div>
            </Sidebar>
          </div>
          <Dialog
            className={styles.loginBox}
            visible={
              user !== undefined &&
              user.loginVisible !== undefined &&
              user.loginVisible
            }
            modal={true}
            closable={true}
            dismissableMask={true}
            onHide={() => {
              if (!user.loginVisible) return;
              dispatch(userActions.setLoginVisible(false));
            }}
            content={({ hide }) => (
              <Stepper className={styles.loginModal} ref={stepperRef}>
                <StepperPanel header="login">
                  <div>
                    <div className={styles.loginContainer}>
                      <div>{header}</div>
                      <form>
                        <div className={styles.inputContainer}>
                          {" "}
                          <InputText
                            className={styles.loginInput}
                            value={user.email}
                            id={user.email}
                            placeholder="Email"
                            onChange={(e) =>
                              onChangeHandler("email", e.target.value)
                            }
                          />
                          <Password
                            feedback={false}
                            className={styles.loginInput}
                            inputClassName={styles.loginInput}
                            value={user.password}
                            type="password"
                            onChange={(e) =>
                              onChangeHandler("password", e.target.value)
                            }
                            placeholder="Contraseña"
                          />
                        </div>
                      </form>
                    </div>
                    <div className="flex flex-column">
                      <Button
                        className={styles.forgotPassword}
                        onClick={openForgotPasswordPage}
                      >
                        <small>¿Olvidaste tu contraseña?</small>
                      </Button>
                      <Button
                        onClick={onRegisterHandler}
                        className={styles.forgotPassword}
                      >
                        <small>Registrarse</small>
                      </Button>
                    </div>
                    <Button
                      onClick={() => onSubmitHandler()}
                      label="Iniciar sesión"
                      className={styles.loginButton}
                    />
                  </div>
                </StepperPanel>
                <StepperPanel header="forgotPassword">
                  <div>
                    <div className={styles.loginContainer}>
                      <div>{header}</div>
                      <div className="flex flex-column">
                        <Button
                          icon={"pi pi-arrow-circle-left"}
                          onClick={() => stepperRef.current.prevCallback()}
                          className={styles.forgotPassword}
                        >
                          <small style={{ marginLeft: "2.5%" }}>Volver</small>
                        </Button>
                      </div>
                      <form style={{ marginTop: "7%" }}>
                        <span className={styles.message}>
                          Ingresa el correo electrónico asociado a tu cuenta
                        </span>
                        <InputText
                          className={styles.forgotPasswordInput}
                          value={user.email}
                          id={user.email}
                          placeholder="Email"
                          onChange={(e) =>
                            onChangeHandler("email", e.target.value)
                          }
                        />
                      </form>
                    </div>

                    <Button
                      onClick={() => onForgotPasswordHandler()}
                      label="Enviar"
                      className={styles.loginButton}
                    />
                  </div>
                </StepperPanel>
              </Stepper>
            )}
          ></Dialog>
        </div>
      )}
    </>
  );
};

export default NavBarMenu;
